const createVideoElement = (solutionElement: HTMLElement, initialVolume: number): HTMLVideoElement => {
    const videoElement = document.createElement('video');

    videoElement.controls = false;
    videoElement.volume = initialVolume;

    if (initialVolume === 0) {
        videoElement.muted = true;
    }

    solutionElement.appendChild(videoElement);

    return videoElement;
};

export default createVideoElement;